import {
  RecoSectionContent,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk'
import { isEdge, isIE } from 'helpers/device'
import { cdnImageUrl } from 'helpers/image'
import { ElementTrackingContextProvider } from 'helpers/tracking/ElementTrackingContext'
import {
  DeferredSectionsTrackingContextProvider,
  RecoSliderSectionTrackingContextProvider,
} from 'helpers/tracking/SectionTrackingContext'
import { StoryPromotionTracker } from 'helpers/tracking/trackerComponents/ElementTracker'
import React, { FC } from 'react'
import Story from 'store/entities/Story/Story.store'
import DividerSection from 'uiComponents/atoms/Sections/DividerSection'
import RowSection from 'uiComponents/atoms/Sections/RowSection'
import StaticStoryHeaderImage from 'uiComponents/molecules/StoryHeaderImage/StaticStoryHeaderImage'
import StoryHeaderImage from 'uiComponents/molecules/StoryHeaderImage/StoryHeaderImage'

interface Props {
  story: Story | null
}

const StoryTrackingSection: FC<React.PropsWithChildren> = ({ children }) => (
  <RecoSliderSectionTrackingContextProvider
    headline=""
    recoType={RecoSectionContent.storyRecommendation}
  >
    {children}
  </RecoSliderSectionTrackingContextProvider>
)

const OdpStoryReco: FC<Props> = ({ story }) => {
  if (!story) {
    return null
  }

  const storyName = story.headline
  const storyImageSrc = cdnImageUrl(story.image)
  const storyHref = story.url

  return (
    <RowSection data-testid="StoryReco" as={DividerSection} pullStart pullEnd>
      <StoryTrackingSection>
        <ElementTrackingContextProvider>
          <StoryPromotionTracker
            storyId={story.id}
            source={TrackingPromotionCreative.StoryReco}
          >
            {isIE || isEdge ? (
              <StaticStoryHeaderImage
                storyName={storyName}
                storyImageSrc={storyImageSrc}
                storyHref={storyHref}
              />
            ) : (
              <StoryHeaderImage
                storyName={storyName}
                storyImageSrc={storyImageSrc}
                storyHref={storyHref}
              />
            )}
          </StoryPromotionTracker>
        </ElementTrackingContextProvider>
      </StoryTrackingSection>
    </RowSection>
  )
}

const TrackedStoryReco: FC<Props> = props => (
  <DeferredSectionsTrackingContextProvider sectionCount={1}>
    <OdpStoryReco {...props} />
  </DeferredSectionsTrackingContextProvider>
)

export default TrackedStoryReco
